import { lazyProperties } from "./_helpers/lazy-properties.mjs";
export const name = "generic";
/**
 * Generic type constructor (not a type itself).
 */
export const GenericType = class {
  constructor(options) {
    this.name = name;
    this._options = options;
    if (typeof options !== "function") {
      this._applyOptions();
    } else {
      lazyProperties(this, this._applyOptions, ["apply"]);
    }
  }
  _applyOptions() {
    if (this._options === undefined) {
      throw new Error("missing `_options` for lazy initialization");
    }
    const options = typeof this._options === "function" ? this._options() : this._options;
    const apply = options.apply;
    Object.assign(this, {
      apply
    });
  }
};
